import React, { ReactNode } from 'react'
import { useDetermineOnMarketplace } from 'shared/state/useDetermineOnMarketplace'

const ConditionalMarketplace = ({
  shown,
  children
}: {
  shown: boolean
  children: ReactNode
}) => {
  const isMarketplace = useDetermineOnMarketplace()

  if (shown) return isMarketplace ? <>{children}</> : <></>
  else return isMarketplace ? <></> : <>{children}</>
}

/**
 * This component conditionally shows its children if on the marketplace.
 */
export const ShowOnMarketplace = ({ children }: { children: ReactNode }) => (
  <ConditionalMarketplace shown={true}>{children}</ConditionalMarketplace>
)

/**
 * This component conditionally hides its children if on the marketplace.
 */
export const HideOnMarketplace = ({ children }: { children: ReactNode }) => (
  <ConditionalMarketplace shown={false}>{children}</ConditionalMarketplace>
)
